hmi.models.HMI = function () {
  "use strict";

  //============================================================
  // Public Variables with Default Settings
  //------------------------------------------------------------

  var margin = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
    width = null,
    height = null,
    duration = 250;

  //============================================================
  // Private Variables
  //------------------------------------------------------------

  var centerTranslate = [0, 0],
    defaultScale = 1,
    minScale = 0.2,
    maxScale = 2;

  var groupType = {
    component: 1,
    pipe: 2,
  };

  var designData = [],
    data = [],
    components = [],
    containerZoom,
    matrixContainer,
    pipes = [],
    showMode = true,
    availableWidth = 0,
    availableHeight = 0,
    fitPadding = 0.75,
    pendingAddObject = null,
    dispatch = d3.dispatch(
      "selectElement",
      "paintComponent",
      "completePipe",
      "selectText",
      "action_run"
    ),
    zoomValue = {
      translate: [0, 0],
      scale: 1,
    },
    initialized = false,
    selectElement = null,
    pipeSize = 1,
    showMatrix = true;

  var xScale = d3.scale.quantize(),
    yScale = d3.scale.quantize();

  var matrix = hmi.models.point_matrix();

  matrix.dispatch.on('click', function(event){
    padClick(event);
  });

  hmi.dragBehavior.dragComponent = d3.behavior
    .drag()
    .on("dragstart", function (d) {
      d3.event.sourceEvent.stopPropagation();
      /* var component = hmi.utils.get_component(d.type);
            if (d.select && hmi.showMode === hmi.constant.showMode.design &&
                component && component.instance && component.instance.dragDropStratCallBack) {
                component.instance.dragDropStratCallBack(d);
            } */
    })
    .on("drag", function (d) {
      if (d.select && hmi.showMode === hmi.constant.showMode.design) {
        d.x = parseInt(d3.event.x);
        d.y = parseInt(d3.event.y);
        var eventX = d3.event.x - d.width / 2;
        var eventY = d3.event.y - d.height / 2;
        var component = hmi.utils.get_component(d.type);
        d3.select(this).attr("transform", function () {
          return "translate(" + eventX + "," + eventY + ")";
        });
        if (component && component.instance) {
          if (component.instance.updateComponentPosition) {
            component.instance.updateComponentPosition(d);
          }
        }
      }
    })
    .on("dragend", function (d, i) {
      if (d.select && hmi.showMode === hmi.constant.showMode.design) {
        d.select = false;
        var component = hmi.utils.get_component(d.type);
        if (component.instance.calcXYPass) {
          var xy = component.instance.calcXYPass(d, xScale, yScale);
          d.x = xy[0];
          d.y = xy[1];
        }
        if (component && component.instance) {
          if (component.instance.updateComponentPosition) {
            component.instance.updateComponentPosition(d);
          }
          if (component.instance.transformComponentPosition) {
            component.instance.transformComponentPosition(this, d);
          }

          hmi.utils.unSelectComponent();
          /* if (component.instance.dragDropEndCallBack) {
                        component.instance.dragDropEndCallBack(d);
                    } */
          component.instance.dispatch.componentChange({
            component: d,
          });
          if (component.instance.pipe) {
            var linkItem = {
              linkId: d.id,
              x: d.x,
              y: d.y,
              width: d.width,
              height: d.height,
              positionPipe: d.positionPipe,
            };
            component.instance.pipe().updateChangeLink(linkItem);
          }
        }
      }
    });

  var zoomBehavior = d3.behavior
    .zoom()
    .scaleExtent([minScale, maxScale])
    .on("zoom", onZoom);

  hmi.utils.load_modules();

  var clearData = function () {
    designData = [];
    data = [];
    components = [];
    pipes = [];
  };

  var buildDesing = function (d) {
    d3.selectAll(".hmi-components > *").remove();
    clearData();
    d.forEach(function (group) {
      var object = hmi.utils.get_component(group.type);
      var designItem = object.instance.getObject(group);
      designData.push(designItem);
    });
    createHMI();
    zoomFit();
  };

  function removeElement(selectID) {
    if (selectID) {
      var indexEle = designData.findIndex(function (item) {
        return item.id === selectID;
      });
      // var i = designData.indexOf(itemEle);
      if (indexEle !== -1) {
        designData.splice(indexEle, 1);
        designData = designData.filter(function (value, index, arr) {
          if (value.link1 === undefined || value.link2 === undefined) {
            return true;
          } else {
            return value.link1.id !== selectID && value.link2.id !== selectID;
          }
        });
        updateHMI();
      }
    }
  }

  var buildFocus = function (focus) {
    var pad = focus
      .append("g")
      .attr("class", "nv-background")
      .append("rect")
      .on("click", function (d) {
        padClick(this);
      })
      .attr("width", availableWidth)
      .attr("height", availableHeight);

    var zoomContainer = focus.append("g").attr("class", "zoom");
    matrixContainer = zoomContainer.append("g").attr("class", "matrix");
    d3.selectAll(".matrixWrap > *").remove();
    d3.selectAll(".matrixWrap").remove();
    containerZoom = zoomContainer.append("g").attr("class", "hmi-components");
    if (showMatrix) {
      matrixContainer.insert("g", ":first-child").attr("class", "matrixWrap");
    }

    d3.select("body").on("keydown", function () {
      if (d3.event.keyCode == 46 && showMode === hmi.constant.showMode.design) {
        // Prevent the browser from going back in the URL history
        // d3.event.preventDefault();
        removeElement(selectElement);
      }
    });

    return pad;
  };

  function padClick(d) {
    // d3.event.stopPropagation();
    hmi.utils.unSelectComponent();
    selectElement = null;
    switch (showMode) {
      case hmi.constant.showMode.design:
        dispatch.selectText(undefined);
        if (pendingAddObject) {
          var dataDesignItem = pendingAddObject;
          var component = hmi.utils.get_component(dataDesignItem.type);
          dataDesignItem.x =
            (d3.mouse(d)[0] - zoomValue.translate[0]) / zoomValue.scale;
          dataDesignItem.y =
            (d3.mouse(d)[1] - zoomValue.translate[1]) / zoomValue.scale;
          if (
            component &&
            component.instance &&
            component.instance.calcXYPass
          ) {
            var xy = component.instance.calcXYPass(
              dataDesignItem,
              xScale,
              yScale
            );
            dataDesignItem.x = xy[0];
            dataDesignItem.y = xy[1];
          } else {
            dataDesignItem.x = xScale(dataDesignItem.x);
            dataDesignItem.y = yScale(dataDesignItem.y);
          }

          dataDesignItem.config = dataDesignItem.config || {};
          dataDesignItem.config.pipeSize = pipeSize;
          pendingAddObject = null;
          dispatch.paintComponent({
            finish: true,
          });
          designData.push(dataDesignItem);
          createHMIItem(component);
        }
        break;
      case hmi.constant.showMode.match:
        if (event.stopPropagation) {
          event.stopPropagation();
        }
        dispatch.selectElement({
          element: undefined,
        });

        break;
    }
  }

  function setZoomTrans() {
    var sizeComponent = 75 * pipeSize;
    var xSteps = hmi.utils.StepsComponents(
      availableWidth * 1.5,
      sizeComponent,
      zoomValue.scale
    );
    var ySteps = hmi.utils.StepsComponents(
      availableHeight * 1.5,
      sizeComponent,
      zoomValue.scale
    );
    xScale.domain(xSteps[0]).range(xSteps[1]);
    yScale.domain(ySteps[0]).range(ySteps[1]);
    hmi.utils.xScale = xScale;
    hmi.utils.yScale = yScale;
    if (showMatrix) {
      d3.selectAll(".matrixWrap > *").remove();
      matrix.sizeComponent(sizeComponent);
      matrix.scale(zoomValue.scale);
      d3.select(".matrixWrap").datum([xSteps, ySteps]).call(matrix);
    }
  }

  var createHMI = function () {
    //setZoomTrans();
    hmi.components.forEach(function (item) {
      item.instance
        // .showMode(hmi.constant.showMode.design)
        .availableWidth(availableWidth)
        .availableHeight(availableHeight);
      //.valueFormat(valueFormat);
      if (item.instance.zoomTrans) {
        item.instance.zoomTrans(zoomValue);
      }
      if (item.instance.dragBehavior) {
        item.instance.dragBehavior(hmi.dragBehavior.dragComponent);
      }
      createHMIItem(item);
    });
  };

  var createHMIItem = function (item) {
    if (item.type === hmi.constant.PIPE) {
      item.instance
        .availableWidth(availableWidth)
        .availableHeight(availableHeight)
        .pipeSize(pipeSize);

      var pipeDesignData = null;
      pipeDesignData = designData.filter(function (d) {
        return d.groupType === groupType.pipe;
      });

      d3.select(".hmi-components")
        .data([pipeDesignData])
        .transition()
        .duration(50)
        .call(item.instance);
    } else {
      var designDataFilter = null;
      designDataFilter = designData.filter(function (d) {
        return d.groupType === groupType.component && d.type === item.type;
      });
      d3.select(".hmi-components")
        .data([designDataFilter])
        .transition()
        .duration(50)
        .call(item.instance);
    }
  };

  var updateHMI = function () {
    hmi.components.forEach(function (item) {
      updateHMIItem(item);
    });
  };

  var updateHMIItem = function (item) {
    if (item.type === hmi.constant.PIPE) {
      item.instance
        .availableWidth(availableWidth)
        .designMode(false)
        .availableHeight(availableHeight)
        .pipeSize(pipeSize);

      var pipeDesignData = designData.filter(function (d) {
        return d.groupType === groupType.pipe;
      });

      d3.select(".hmi-components")
        .datum(pipeDesignData)
        .transition()
        .duration(100)
        .call(item.instance);
    } else {
      item.instance
        .availableWidth(availableWidth)
        .availableHeight(availableHeight);
      //.valueFormat(valueFormat);

      if (item.instance.zoomTrans) {
        item.instance.zoomTrans(zoomValue);
      }
      if (item.instance.dragBehavior) {
        item.instance.dragBehavior(hmi.dragBehavior.dragComponent);
      }

      var componentDesignData = null;
      var componentDesignData = designData.filter(function (d) {
        return d.groupType === groupType.component && d.type === item.type;
      });

      d3.select(".hmi-components")
        .datum(componentDesignData)
        .transition()
        .duration(100)
        .call(item.instance);
    }
  };

  var updateZoomTrans = function () {
    hmi.components.forEach(function (item) {
      // item.instance
      //     .availableWidth(availableWidth)
      //     .availableHeight(availableHeight);
      if (item.instance.zoomTrans) {
        item.instance.zoomTrans(zoomValue);
        setZoomTrans();
      }
    });
  };

  var createAlias = function (dataDesignItem) {
    var result = "";
    switch (dataDesignItem.component.type) {
      case hmi.constant.VALV_1:
        result = "valv1";
        break;
      case hmi.constant.VALV_2:
        result = "valv2";
        break;
      case hmi.constant.VALV_3:
        result = "valv3";
        break;
      case hmi.constant.SINK:
        result = "sink";
        break;
      case hmi.constant.VALV:
        result = "valv";
        break;
    }
    return result + " - " + (designData.length + 1);
  };

  function onZoom() {
    zoom(d3.event.translate, d3.event.scale);
  }

  var zoom = function (translate, scale) {
    zoomValue.translate = translate;
    zoomValue.scale = scale;
    var hmiComponentsSelect = d3.select(HMI.container).select(".zoom");
    hmiComponentsSelect.attr(
      "transform",
      "translate(" + zoomValue.translate + ")scale(" + zoomValue.scale + ")"
    );
    
  };

  function zoomFit(padding) {
    fitPadding = padding || fitPadding;
    var hmiComponentsSelect = d3
      .select(HMI.container)
      .select(".hmi-components");
    var node = hmiComponentsSelect.node();
    if (node === null || node === undefined) return;

    var bounds = node.getBBox();
    var fullWidth = d3.select(HMI.container).node().clientWidth,
      fullHeight = d3.select(HMI.container).node().clientHeight;
    var width = bounds.width * zoomValue.scale,
      height = bounds.height * zoomValue.scale;
    if (width == 0 || height == 0) return; // nothing to fit
    var scale = Math.min(fullWidth / width, fullHeight / height);
    scale = scale * zoomValue.scale * fitPadding;
    if (scale < 1) {
      scale = Math.max(scale, minScale);
    } else {
      scale = Math.min(scale, maxScale);
    }

    (width = bounds.width * scale), (height = bounds.height * scale);
    var midX = bounds.x * scale + width / 2,
      midY = bounds.y * scale + height / 2;
    var translate = [fullWidth / 2 - midX, fullHeight / 2 - midY];
    hmiComponentsSelect
      .transition()
      .duration(0)
      .call(zoomBehavior.translate(translate).scale(scale).event);
    // zoom(translate, scale);
  }

  function HMI(selection) {
    selection.each(function (dataSelection) {
      data = dataSelection;

      if (!data || !data.length) {
        designData = [];
      }
      // match data with design
      for (var i = 0; i < dataSelection.length; i++) {
        var selData = dataSelection[i];
        var key = dataSelection[i].key;
        var designItemIndex = designData.findIndex(function (element) {
          return element.key === key;
        });
        if (designItemIndex !== -1) {
          designData[designItemIndex].data = dataSelection[i].data;
        }
      }

      var container = d3.select(this);
      hmi.utils.initSVG(container);
      if (!initialized) {
        container.call(zoomBehavior).on("dblclick.zoom", null);
        initialized = true;
      }

      availableWidth = hmi.utils.availableWidth(width, container, margin);
      availableHeight = hmi.utils.availableHeight(height, container, margin);

      HMI.container = this;

      // Setup containers and skeleton of chart
      var wrap = container.selectAll("g.nv-wrap").data([data]);
      var gEnter = wrap
        .enter()
        .append("g")
        .attr("class", "nvd3 nv-wrap")
        .append("g");
      var g = wrap.select("g");

      gEnter.append("g").attr("class", "nv-legendWrap");

      var focus = gEnter.append("g").attr("class", "nv-focus");
      //.data([designData]);

      var pad = buildFocus(focus);

      g.select(".nv-focus .nv-background rect")
        .attr("width", availableWidth)
        .attr("height", availableHeight);

      setZoomTrans();
      // zoom(centerTranslate, defaultScale);

      HMI.update = function () {
        updateHMI();
        zoomFit(0.8, 0);
      };

      updateHMI();
    });

    return HMI;
  }

  //============================================================
  // Event Handling/Dispatching (out of chart's scope)
  //------------------------------------------------------------

  hmi.components.forEach(function (item) {
    if (item.instance === null) {
      return;
    }

    if (item.type === hmi.constant.PIPE) {
      item.instance.dispatch.on("addCompletePipe", function (d) {
        pendingAddObject = null;
        designData.push(d.pipe);
        createHMIItem(item);
        dispatch.completePipe({
          completePipe: true,
        });
      });

      item.instance.dispatch.on("componentChange", function (d) {
        var componentIndex = designData.findIndex(function (element) {
          return element.id === d.component.id;
        });
        if (componentIndex !== -1) {
          designData[componentIndex] = d.component;
          updateHMIItem(item);
        }
      });
    } else {
      item.instance.dispatch.on("componentChange", function (d) {
        var componentIndex = designData.findIndex(function (element) {
          return element.id === d.component.id;
        });
        if (componentIndex !== -1) {
          designData[componentIndex] = d.component;
          updateHMIItem(item);
        }
      });
      if (item.instance.dispatch.selectElement) {
        item.instance.dispatch.on("selectElement", function (d) {
          if (event.stopPropagation) {
            event.stopPropagation();
          }
          dispatch.selectElement({
            element: d.component,
            signal: d.signal,
            has_pipe: d.has_pipe,
          });
          selectElement = d.component;
        });
      }
      if (item.instance.action_execute) {
        item.instance.action_execute().dispatch.on("action_run", function (d) {
          dispatch.action_run(d);
        });
      }
      if (item.instance.dispatch.selectText) {
        item.instance.dispatch.on("selectText", function (d) {
          if (event.stopPropagation) {
            event.stopPropagation();
          }
          dispatch.selectText(d);
        });
      }
      if (item.instance.pipe) {
        item.instance.pipe().dispatch.on("selectElement", function (d) {
          // object.instance.pendingPipe(data);
          dispatch.selectElement({
            element: d.component,
            signal: d.signal,
            has_pipe: d.has_pipe,
          });
          selectElement = d.component;
        });
      }
    }
  });

  //
  // //============================================================
  // // Expose Public Variables
  // //------------------------------------------------------------
  //

  HMI.importDesing = function HMI(designData) {
    buildDesing(designData);
  };

  HMI.exportDesing = function HMI() {
    return designData;
  };

  HMI.dispatch = dispatch;

  HMI.options = hmi.utils.optionsFunc.bind(HMI);

  HMI._calls = new (function () {
    var call = this;
    this.addObject = function (type, data) {
      var object = hmi.utils.get_component(type);
      if (type !== hmi.constant.PIPE) {
        pendingAddObject = object.instance.getObject(data);
        if (object.pipe) {
          object.instance
            .pipe()
            .dispatch.on("pendingPipeChange", function (data) {
              object.instance.pendingPipe(data);
            });
        }
      } else {
        hmi.utils.addPendingPipe(undefined);
        var pipe = object.instance.getPendingObject(data);
        hmi.utils.addPendingPipe(pipe);
      }
    };

    this.removeElement = function () {
      removeElement(selectElement);
    };
    this.configValues = function (_) {
      _.forEach(function (conf) {
        var value = designData.find(function (item) {
          return item.key === conf.key;
        });
        if (value) {
          var conmponet = hmi.utils.get_component(value.type);
          if (
            conmponet &&
            conmponet.instance &&
            conmponet.instance.updateConfig &&
            value.type !== hmi.constant.PIPE
          ) {
            value = conmponet.instance.updateConfig(conf);
          }
          if (
            conmponet &&
            conmponet.instance &&
            conmponet.instance.updateConfig &&
            value.type === hmi.constant.PIPE
          ) {
            value = conmponet.instance.updateConfig(value, conf);
          }
        }
      });
      updateHMI();
    };
    this.configAllValues = function (conf) {
      if (conf.config.pipeSize <= 0.2) {
        return;
      }
      pipeSize = conf.config.pipeSize;
      setZoomTrans();
      designData.forEach(function (item) {
        var component = hmi.utils.get_component(item.type);
        if (component.instance.calcXYPass) {
          var xy = component.instance.calcXYPass(item, xScale, yScale);
          item.x = xy[0];
          item.y = xy[1];
        }

        if (component.instance.updateComponentPosition) {
          component.instance.updateComponentPosition(item);
        }

        if (item.config) {
          item.config.pipeSize = conf.config.pipeSize;
        } else {
          item.config = {
            pipeSize: conf.config.pipeSize,
          };
        }
        component.instance.dispatch.componentChange({
          component: item,
        });
        if (component.instance.pipe) {
          var linkItem = {
            linkId: item.id,
            x: item.x,
            y: item.y,
            width: item.width,
            height: item.height,
            positionPipe: item.positionPipe,
          };
          component.instance.pipe().updateChangeLink(linkItem);
        }
      });
      call.configValues(designData);
    };

    this.resetZoom = function () {
      zoom(centerTranslate, defaultScale);
    };

    this.zoomFit = zoomFit;
  })();

  HMI._options = Object.create(
    {},
    {
      // simple options, just get/set the necessary values
      // valueFormat: {
      //     get: function () {
      //         return valueFormat;
      //     },
      //     set: function (_) {
      //         valueFormat = _;
      //     }
      // },
      pendingAddObject: {
        get: function () {
          return pendingAddObject;
        },
        set: function (_) {
          pendingAddObject = _;
        },
      },
      showMode: {
        get: function () {
          return showMode;
        },
        set: function (_) {
          showMode = _;
          hmi.showMode = _;
          hmi.components.forEach(function (item) {
            if (item.instance.showMode) {
              item.instance.showMode(showMode);
            }
          });
        },
      },
      showMatrix: {
        get: function () {
          return showMatrix;
        },
        set: function (_) {
          showMatrix = _;
          hmi.showMatrix = _;
          d3.selectAll(".matrixWrap > *").remove();
          d3.selectAll(".matrixWrap").remove();
          if (_) {
            if (matrixContainer) {
              matrixContainer
                .insert("g", ":first-child")
                .attr("class", "matrixWrap");
              setZoomTrans();
            }
          }
        },
      },
    }
  );

  hmi.components.forEach(function (item) {
    hmi.utils.exprotFunc(HMI, item.instance);
  });

  hmi.utils.initOptions(HMI);

  return HMI;
};
